import { Appearance, Mode } from "../types";

export const getAppearanceModeBackground = (type: 'controls' | 'paper') =>
  (appearance: Appearance, mode: Mode) => {

  const colorDefaultAppearance = type === 'controls' ? 'var(--colorGray)' : 'var(--colorPanel)'
  if (appearance === 'default') {
    return colorDefaultAppearance
  }
  if (appearance === 'outline' || appearance === 'plain' || appearance === 'overlay') {
    return 'transparent'
  }

  switch (mode) {
    case 'primary':
      return appearance === 'tinted' ? "var(--colorBlueAlpha)" : "var(--colorBlue)"
    case 'success':
      return appearance === 'tinted' ? "var(--colorGreenAlpha)" : "var(--colorGreen)"
    case 'danger':
      return  appearance === 'tinted' ? "var(--colorRedAlpha)" : "var(--colorRed)"
    case 'warn':
      return  appearance === 'tinted' ? 'var(--colorOrangeAlpha)' : 'var(--colorOrange)'
    case 'secondary':
    default:
      return appearance === 'tinted' ? "var(--colorFill4Alpha)" : colorDefaultAppearance
  }
}